var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.99999,
    cy: 8.6928,
    rx: 5.78571,
    ry: 5.78571,
    transform: "rotate(-180 8.99999 8.6928)",
    fill: "#48BB78"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.73273,
    cy: 9.63046,
    r: 6.5,
    transform: "rotate(124 8.73273 9.63046)",
    fill: "#F56565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4502 9.47825C17.5343 14.2939 13.7006 18.2638 8.88496 18.3478C4.06929 18.4319 0.0994362 14.5983 0.0153783 9.78258C-0.0686796 4.96691 3.76496 0.99705 8.58064 0.912992C13.3963 0.828934 17.3662 4.66258 17.4502 9.47825ZM12.3848 8.5505L9.88622 11.2488L9.77418 4.83026C9.76602 4.36275 9.38334 3.9932 8.91584 4.00136L8.35342 4.01118C7.88592 4.01934 7.51637 4.40202 7.52453 4.86953L7.63656 11.2881L5.04532 8.67861C4.71246 8.34335 4.1675 8.34583 3.83939 8.68559L3.463 9.07894C3.13835 9.41513 3.14767 9.94942 3.4838 10.2706L8.22623 14.8537C8.56241 15.1784 9.09671 15.169 9.41784 14.8329L14.0009 10.087C14.3256 9.75079 14.3163 9.2165 13.9801 8.89536L13.5903 8.51539C13.2505 8.18729 12.7058 8.20383 12.3848 8.5505Z",
    fill: "#FED7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 18,
    height: 20,
    transform: "rotate(-180 18 20)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.3dd894bae184496e4cc8514a60874ce2.svg";
export { ForwardRef as ReactComponent };